import React from "react";

const Vision = () => {
  return (
    <section className="py-16 px-6 md:px-20 bg-gray-50 text-gray-800">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-6">Our Vision</h2>
        <p className="text-lg leading-8">
          Our vision at DHIKROO International Islamic Academy is to become a globally recognized
          institution that fosters academic excellence and moral uprightness rooted in Islamic values.
          We aim to inspire future leaders who will contribute positively to society with integrity,
          wisdom, and compassion—spreading knowledge, peace, and enlightenment wherever they go.
        </p>
      </div>
    </section>
  );
};

export default Vision;
